// extracted by mini-css-extract-plugin
module.exports = {"M":"hero_M__l-SDk","Hero":"hero_Hero__1FBKR","CallToAction":"hero_CallToAction__2rore"};